import React from 'react'
import {Modal, Button} from 'react-bootstrap'



const PopupModel = (props)=>{

    return(
        <Modal
            show={props.show} 
            onHide={props.hide}
            centered
            size="bg">
            <div style={{flexDirection: 'column', padding: 30}}>
                <div>
                    <span>{props.content}</span>
                </div>
                <div style={{display: 'flex',margin: 'auto', justifyContent: 'space-between'}} className="mt-4">
                    <Button variant="light" onClick={props.hide}>Cancel</Button>
                    {!props.hideBtn && <Button variant="success" onClick={props.handleConfirm}>{props.btnText}</Button>}
                </div>
            </div>
        </Modal>
    )
}
export default PopupModel